<template>
  <div class="w-full h-full">
    <div class="relative flex flex-col w-full h-full">
      <two-blocks-layout :navigate="navigate" v-bind="page" class="my-auto" col>
        <span
          class="text-title-sm md:text-title-md"
          v-text="`${page.titolo1}`"
        />
        <template #right>
          <instagram-gallery
            class="mx-auto"
            v-if="page"
            :ig-key="page.key"
            :page-id="page.pageId"
          />
        </template>
      </two-blocks-layout>
      <app-cta-button
        cta
        mobile-only
        full-width
        :link="apriContoUrl"
        external
      />
    </div>
  </div>
</template>

<script>
import { axios } from "@/plugins/axios";
import TwoBlocksLayout from "@/components/page-layouts/TwoBlocksLayout.vue";
import InstagramGallery from "@/components/InstagramGallery.vue";

export default {
  components: { TwoBlocksLayout, InstagramGallery },
  props: { navigate: { default: null } },
  async beforeRouteEnter(to, from, next) {
    let page;
    try {
      page = await axios.get(`/pageContent${to.path}.json`);
    } catch (error) {
      page = {};
    } finally {
      next(vm => (vm.page = page.data));
    }
  }
};
</script>
<route>
{
  "name": "Storie Controcorrente",
  "meta": {
      "order": 10,
      "label": "Storie ControCorrente",
      "hideMenu": {
        "inline": true,
        "main": true
      },
      "disabledRoute": true
  }
}
</route>
